<div class="section position-relative">
    <div class="section-top">
        <h3 class="section-title">Operatori</h3>
        <div clasas="section-top-actions">
            <button type="button" class="btn btn-sm btn-info pull-right ms-1" (click)="rerenderDT(false)">
                <i class="fa-solid fa-arrows-rotate"></i>
            </button>
        </div>
    </div>
    <div class="card-container p-2" *ngIf="showCard">
        <form [formGroup]="searchParamsForm" (ngSubmit)="applyFilters()">
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>Nume</mat-label>
                        <input matInput type="text" formControlName="name" />
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>Funcție</mat-label>
                        <mat-select formControlName="functie">
                            <mat-option *ngFor="let functie of functii" [value]="functie.id">
                                {{ functie.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>Semnătură</mat-label>
                        <mat-select formControlName="signature">
                            <mat-option value="-1">Toate</mat-option>
                            <mat-option value="1">Cu semnătură</mat-option>
                            <mat-option value="0">Fără semnătură</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="divider-container mb-2">
                <div class="line"></div>
                <span class="text">Organigramă</span>
                <div class="line"></div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>Direcție</mat-label>
                        <mat-select formControlName="directie" (openedChange)="onDirectieClosed()"
                            (selectionChange)="onDirectieChange($event.value)">
                            <mat-form-field class="px-2 sticky-input">
                                <input matInput [formControl]="directiiControl" (keydown)="$event.stopPropagation()"
                                    (click)="$event.stopPropagation()" />
                            </mat-form-field>

                            <mat-option value="-1">Toate</mat-option>

                            <mat-option *ngFor="let directie of filteredDirectii" [value]="directie.id">
                                {{ directie.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>Compartiment</mat-label>
                        <mat-select formControlName="compartiment" (openedChange)="onCompartimentClosed()">
                            <mat-form-field class="px-2 sticky-input">
                                <input matInput [formControl]="compartimenteControl"
                                    (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                            </mat-form-field>

                            <mat-option value="-1">Toate</mat-option>

                            <mat-option *ngFor="let compartiment of filteredCompartimente" [value]="compartiment.id">
                                {{ compartiment.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="divider-container mb-2">
                <div class="line"></div>
                <span class="text">Acces</span>
                <div class="line"></div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>Direcție</mat-label>
                        <mat-select formControlName="active_directie" (openedChange)="onDirectieActiveClosed()"
                            (selectionChange)="onDirectieActiveChange($event.value)">
                            <mat-form-field class="px-2 sticky-input">
                                <input matInput [formControl]="directiiActiveControl"
                                    (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                            </mat-form-field>

                            <mat-option value="-1">Toate</mat-option>

                            <mat-option *ngFor="let directie of filteredDirectiiActive" [value]="directie.id">
                                {{ directie.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>Compartiment</mat-label>
                        <mat-select formControlName="active_compartiment" (openedChange)="onCompartimentActiveClosed()">
                            <mat-form-field class="px-2 sticky-input">
                                <input matInput [formControl]="compartimenteActiveControl"
                                    (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                            </mat-form-field>

                            <mat-option value="-1">Toate</mat-option>

                            <mat-option *ngFor="let compartiment of filteredCompartimenteActive"
                                [value]="compartiment.id">
                                {{ compartiment.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="row w-100">
                <div class="col d-flex justify-content-start">
                    <button (click)="toggleCard()" type="button"
                        class="btn btn-sm btn-warning closeBtn">Închide</button>
                </div>
                <div class="col buttons-submit">
                    <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                        Resetează
                    </button>
                    <button type="submit" class="btn btn-sm btn-primary ms-2">
                        Aplică
                    </button>
                </div>
            </div>
            <div class="section-spinner position-absolute" *ngIf="isFilterLoading">
                <div class="spinner position-absolute top-50 start-50 translate-middle">
                    <mat-spinner></mat-spinner>
                    <h3 class="mt-2">
                        {{ helper.dialogConfig.generalMessages.pleaseWait }}
                    </h3>
                </div>
            </div>
        </form>
    </div>
    <div class="col-sm-12 ps-3">
        <button type="button" class="btn btn-sm btn-default" (click)="toggleCard()" [class.active]="showCard">
            <i class="fa-solid fa-filter"></i> Filtre
        </button>
    </div>
    <div class="table-container position-relative">
        <table id="datatable" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover w-100">
        </table>
    </div>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>